<template>
  <div :class="s.contentIntroduce">
    <img :src="require('../../images/ic_logo.png')" :class="s.logo" />

    <h2 :class="s.sectionTitle">一、关于我们</h2>
    <p>广东智选保险代理有限公司（简称“智选保代”）成立于2007年，是经国家金融监督管理总局批准设立的全国性保险代理机构。公司总部位于广东省广州市，注册资本为5000万元人民币。业务范围为在全国区域内（港、澳、台除外）代理销售保险产品，是具有全国性互联网销售资质的保险专业中介机构。智选保代自营的智选保险管理系统已获得信息系统安全保护第三级认证，并通过国家监督管理总局信息化系统验收。</p>
    <p>在区域服务拓展方面，智选保代于2023年在湖北省设立省级分公司，进一步强化本地化服务能力。湖北分公司作为公司在华中地区的重要支点，致力于为当地用户提供更贴近、更便捷的保险服务支持，并积极融入区域汽车与科技生态，推动智能保险服务在华中市场的创新与实践，助力公司全国化服务网络持续完善。</p>

    <h2 :class="s.sectionTitle">二、 核心优势</h2>
    <p><strong>1.科技赋能，智能驱动</strong></p>
    <p>致力于通过“在线化、数字化、智能化”的创新保险服务模式与线下保险服务进行有机融合，高效衔接客户保险服务全流程，协助车企和保险行业有效降低保险业务综合运营成本，提升保险业务各流程及关键节点的处理效率，使保险服务更加便捷、透明。</p>
    <p><strong>2.深耕场景，生态融合</strong></p>
    <p>依托小鹏汽车业务资源，积极探索智能保险服务的高质量发展路径，以智能汽车、智能网联生态圈作为主要保险服务场景，专注于深耕中国领先的智能汽车、智能网联生态领域，拓展并创新智能车险服务模式，为用户提供贴合用车全生命周期的保障方案。</p>
    <p><strong>3.股东背景，稳健经营</strong></p>
    <p>公司作为小鹏集团（XPeng Inc.）旗下企业，由母公司广州雪涛企业管理有限公司直接控股，具备坚实的产业资源与信用背书。自2023年完成战略性收购并更名为“智选保代”以来，公司持续深化集团内部治理协同，不断优化治理结构，确保企业稳健合规发展。</p>

    <h2 :class="s.sectionTitle">三、合作伙伴</h2>
    <p>智选保代凭借专业的服务能力与强大的资源整合实力，已与多家头部保险公司建立了深度战略合作关系。</p>
    <p>2023年4月14日，智选保代开业揭幕暨合作签约仪式在小鹏汽车智能产业园区成功举办，小鹏汽车副董事长 联席总裁顾宏地、广东智选保险代理有限公司负责人、市、区金融监管部门领导以及相关保司领导出席活动。并与中国人民财产保险、中国太平洋财产保险、中国平安财产保险、中国人寿财产保险、阳光财产保险等5家保险公司的省级分支机构签署合作协议，共同致力于探索与落地保险科技在智能汽车的应用，拓展和创新智能车险服务用户的新模式。</p>
    <div :class="s.partnerImages">
      <img :src="require('../../images/ic_info1.jpg')"/>
      <img :src="require('../../images/ic_info2.jpg')"/>
    </div>
    <p>截至2025年12月，智选保代共与人保财险、平安财险、太保财险、国寿财险、中华财险、阳光财险、太平财险、申能财险8家保险公司建立了战略合作关系，在车险、非车险等多元领域实现了系统直连与产品互通，为客户提供了更加全面、高效的风险保障服务。</p>

    <h2 :class="s.sectionTitle">四、发展愿景</h2>
    <p>未来，广东智选保险代理有限公司将始终秉持以客户为中心的理念，以科技为驱动，深入拓展智能汽车与网联生态领域。公司将持续探索“线上+线下”深度融合的服务新模式，打通保险、用户与出行生态圈之间的联系，助力行业数字化转型，致力于成为每一位用户最值得信赖的智能保险伙伴。让保险更智能，让服务更简单。</p>
  </div>
</template>

<script>
export default {
  name: 'ContentIntroduce',
  computed: {
    s() {
      return this.$style;
    }
  }
};
</script>

<style scoped lang="less" module>
.contentIntroduce {
  font-size: 15px;
  line-height: 30px;
  text-indent: 2em;

  img {
    max-width: 70%;
    object-fit: cover;
  }
}

.logo {
  text-indent: 0;
}

.sectionTitle {
  text-indent: 0;
  font-size: 18px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 10px;
}

.partnerImages {
  text-indent: 0;
  text-align: center;
  margin: 15px 0;

  img {
    display: block;
    margin: 10px auto;
    max-width: 70%;
  }
}
</style>
